import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberCampaignFromSearch, storeLinksFor } from './storeLinks';

// Returns a function that takes a page's own store links and returns the
// links to use: the ad campaign's links when the visitor came from an ad,
// otherwise the page's own links unchanged.
export function useStoreLinks() {
  const { search } = useLocation();
  return (appStore, playStore) => storeLinksFor({ search, appStore, playStore });
}

// Remembers utm_campaign on every page, including pages without store
// buttons, so a later page in the same visit still carries it.
export function CampaignMemory() {
  const { search } = useLocation();
  useEffect(() => {
    rememberCampaignFromSearch(search);
  }, [search]);
  return null;
}
